/**
 * Image gallery functionality
 * @class
 */
export default class ListingNavigation {
    /**
     * @constructor
     * @param {HTMLElement} element The listing filters root element
     */
    constructor(element) {
        this.element = element;
        this.items = element.querySelectorAll('[data-button="ListingFilter"]');
        this.siteHeader = document.querySelector('[data-component="SiteHeader]');
        //console.log(this.element)
        this.items.forEach(item => item.addEventListener('click', this.removeFilter));
        if (this.items.length > 0) {
            this.element.scrollIntoView();
        }
        //console.log('Listing Navigation', this)
    }
    removeFilter(event) {
        var _a;
        //console.log(event)
        const target = event.target;
        const button = target.closest('[data-button="ListingFilter"]');
        const filter = button === null || button === void 0 ? void 0 : button.getAttribute('data-value');
        const currentUrl = new URL(window.location.href);
        const params = new URLSearchParams(currentUrl.search);
        const activeFilters = (_a = params.get('filters')) === null || _a === void 0 ? void 0 : _a.split('|');
        params.delete('filters');
        const remove = activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.filter(item => item !== filter).join('|');
        if (remove) {
            params.set('filters', remove);
            const newUrl = new URL(`${location.protocol}//${location.host}${location.pathname}?${params.toString()}`);
            window.location.href = newUrl;
        }
        else {
            window.location.href = new URL(`${location.protocol}//${location.host}${location.pathname}?${params.toString()}`);
        }
    }
    /**
     * Creates new instances of IListingNavigationUtils for each `[data-component="ListingNavigation"]` element,
     * and adds the necessary event listeners to support opening and closing of the navigation.
     */
    static init() {
        const listingFilters = [
            ...document.querySelectorAll('[data-component="ListingNavigation"]'),
        ];
        listingFilters.forEach((gallery) => {
            const listingFiltersUtil = new ListingNavigation(gallery);
        });
    }
}
